import { Outlet, createRootRoute, useMatches } from '@tanstack/react-router';
import { z } from 'zod';

import { FipAuthGuard } from '../../components/Auth/FipAuthGuard';
import { PidAuthGuard } from '../../components/Auth/PidAuthGuard';
import { getRunsInFip } from '../../helpers/getRunsInFip';

const RootInner = () => {
	const matches = useMatches();
	const shouldDisableAuthGuard = matches.some(
		(match) => match.staticData.disableAuthGuard,
	);

	if (shouldDisableAuthGuard) {
		return <Outlet />;
	}

	const runsInFip = getRunsInFip();

	const AuthGuard = runsInFip ? FipAuthGuard : PidAuthGuard;

	return (
		<AuthGuard>
			<Outlet />
		</AuthGuard>
	);
};

export const rootRoute = createRootRoute({
	validateSearch: z.object({
		sessionId: z.coerce.string().optional(),
	}),
	component: RootInner,
});
